export default __webpack_public_path__ + "static/media/no-post.975be1ff.png";